<script setup lang="ts">
import { useTemplateRef } from "vue";
import { css } from "./css";
import { NuxtRoutedPage } from "~/components/nuxt-routed-page";
import { MobileHeader } from "~/components/mobile-header";
import { SocialMediaLinks } from "~/components/social-media-links";
import { useHeaderHeight } from "~/composables/use-header-height";
import { computed } from "#imports";

const showHeader = computed(() => false);
const showFooter = computed(() => false);
const showAuth = computed(() => true);
const showLocale = computed(() => true);
const headerTitle = computed(() => "");

const headerEl = useTemplateRef("headerEl");
const { initHeaderObserver } = useHeaderHeight();

initHeaderObserver(headerEl);
</script>

<template>
  <div :class="css()">
    <div v-show="showHeader" ref="headerEl" :class="css('header')">
      <MobileHeader
        :title="headerTitle"
        :show-auth="showAuth"
        :show-locale="showLocale"
      />
    </div>
    <div :class="[css('content'), !showHeader && css('content', 'headless')]">
      <NuxtRoutedPage />
    </div>
    <footer v-show="showFooter" :class="css('footer')">
      <SocialMediaLinks />
    </footer>
  </div>
</template>

<style lang="scss" scoped>
.layouts-mobile-app {
  display: flex;
  flex-direction: column;
  min-width: 100dvw;
  min-height: 100dvh;

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;

    > * {
      width: 100%;
    }
  }

  &__footer {
    padding-inline: var(--spacing-md);
    padding-bottom: var(--spacing-md);
    display: flex;
  }
}
</style>
